import { transient, autoinject } from "aurelia-framework";
import { BannerGrouping, GetBannerResponse } from "../../../../../../models/vessels/vessel.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import * as Enumerable from "linq";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";

@autoinject
@transient()
export class ConfirmListRequestVetDialog {
    
    banners: GetBannerResponse[];
    onContinue: () => void;
    isRsAdmin: boolean;

    constructor(private dialogClient: DialogClientService, private userCliamsService: UserClaimsService) {
    }

    activate(model: { bannerGroups: BannerGrouping[], onContinue: () => void }) {
        this.isRsAdmin = this.userCliamsService.hasPermission(Claims.RightShipUser);
        this.banners = Enumerable.from(model.bannerGroups).selectMany(x => x.response).toArray();
        this.onContinue = model.onContinue;
    }

    cancel() {
        this.dialogClient.hide();
    }

    continue() {
        this.dialogClient.hide();

        if (this.onContinue) {
            this.onContinue();
        }
    }
}